import template from './contract-type.jade';
import contractType from '../../../enums/contract-type';

export default angular
    .module('cian.addForm.contractType', [])
    .directive('cianAfPriceAndDealTermsContractType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.contractTypes = contractType;
        },
        controllerAs: 'contractType',
        template,
    }))
    .name;
